import React, { PropsWithChildren } from "react"
import { useLocation } from "@reach/router"

import defaultImage from "../../images/socials/social-image.png"
import { useSiteMetadata } from "~utils/hooks/site-metadata"

type Script = Record<string, string | boolean>

type SEOProps = {
    title?: string
    description?: string
    imageUrl?: string
    imageRelative?: string
    scripts?: Script[]
} & PropsWithChildren

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    imageUrl,
    imageRelative,
    scripts,
    children,
}) => {
    const { pathname } = useLocation()
    const {
        title: defaultTitle,
        description: defaultDescription,
        siteUrl,
        twitterUsername,
    } = useSiteMetadata()

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: imageUrl || `${siteUrl}${imageRelative || defaultImage}`,
        url: `${siteUrl}${pathname}`,
    }

    return (
        <>
            <title>
                {seo.title}
                {title && " | Chckvet"}
            </title>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            {pathname === "/" && (
                <meta
                    name="facebook-domain-verification"
                    content="gn9ngeb2wwjbvculu6l2k9ejigucoi"
                />
            )}
            {seo.url && <meta property="og:url" content={seo.url} />}

            {seo.title && <meta property="og:title" content={seo.title} />}

            {seo.description && (
                <meta property="og:description" content={seo.description} />
            )}

            {seo.image && <meta property="og:image" content={seo.image} />}

            <meta name="twitter:card" content="summary_large_image" />

            {twitterUsername && (
                <meta name="twitter:creator" content={twitterUsername} />
            )}

            {seo.title && <meta name="twitter:title" content={seo.title} />}

            {seo.description && (
                <meta name="twitter:description" content={seo.description} />
            )}

            {seo.image && <meta name="twitter:image" content={seo.image} />}
            <script>
                {`
                    !function () {
                        var reb2b = window.reb2b = window.reb2b || [];
                        if (reb2b.invoked) return;
                        reb2b.invoked = true;
                        reb2b.methods = ["identify", "collect"];
                        reb2b.factory = function (method) {
                            return function () {
                                var args = Array.prototype.slice.call(arguments);
                                args.unshift(method);
                                reb2b.push(args);
                                return reb2b;
                            };
                        };
                        for (var i = 0; i < reb2b.methods.length; i++) {
                            var key = reb2b.methods[i];
                            reb2b[key] = reb2b.factory(key);
                        }
                        reb2b.load = function (key) {
                            var script = document.createElement("script");
                            script.type = "text/javascript";
                            script.async = true;
                            script.src = "https://s3-us-west-2.amazonaws.com/b2bjsstore/b/" + key + "/reb2b.js.gz";
                            var first = document.getElementsByTagName("script")[0];
                            first.parentNode.insertBefore(script, first);
                        };
                        reb2b.SNIPPET_VERSION = "1.0.1";
                        reb2b.load("W6Z57H0L32OX");
                    }();
                `}
            </script>
            {scripts?.map(script => {
                const { ...attributes } = script
                return <script key={script.src as string} {...attributes} />
            })}
            {children}
        </>
    )
}

export default SEO
